import { render, staticRenderFns } from "./RemoveRepair.vue?vue&type=template&id=6ae3b2ea&scoped=true&"
import script from "./RemoveRepair.vue?vue&type=script&lang=js&"
export * from "./RemoveRepair.vue?vue&type=script&lang=js&"
import style0 from "./RemoveRepair.vue?vue&type=style&index=0&id=6ae3b2ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae3b2ea",
  null
  
)

export default component.exports